export default "__VITE_ASSET__C7XeFkX6__"